import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from '../core/services/notification.service';
import { LoadingService } from '../core/services/loading.service';

@Component({
  selector: 'app-push-modal',
  templateUrl: './push-modal.component.html',
  styleUrls: ['./push-modal.component.scss'],
})
export class PushModalComponent {
  @Input() public users: any;
  title: string = '';
  text: string = '';

  constructor(public modalService: NgbModal, private notificationService: NotificationService, private loadingService: LoadingService) {}

  //푸시 보내기
  async sendPush() {
    this.loadingService.show();
    // 푸시보내기
    let obj = {
      title: this.title,
      content: this.text,
    };

    // 회원의 고유 uid 값만 가져오기
    const checkedUser = this.users.map(v => v.uuid);

    // 한 회원에게 여러번 보내는것을 방지하기 위해서 중복제거 처리 진행
    const sendUsers = [...new Set(checkedUser)];
    for await (let uuid of sendUsers) {
      this.notificationService.memberPush(obj, uuid);
    }

    this.loadingService.hide();

    this.modalService.dismissAll();
  }
}
